import React from 'react';
import { StackOwnProps } from '@mui/material';
import HolidayIcon from 'assets/icons/HolidayIcon';
import UsersIcon from 'assets/icons/UsersIcon';
import StopWatchIcon from 'assets/icons/StopWatchIcon';
import UserSearchIcon from 'assets/icons/UserSearchIcon';
import WalletIcon from 'assets/icons/WalletIcon';
import OfficeChairIcon from 'assets/icons/OfficeChairIcon';
import { ModuleTypes } from 'enums';
import { wrapperHeight, wrapperWidth } from './consts';

export interface Module {
  label: string;
  type: ModuleTypes;
  sx: StackOwnProps['sx'];
  requiredModules?: ModuleTypes[];
  price?: number;
  pricePerUser?: number;
  icon: JSX.Element;
}

const nodules: Module[] = [
  {
    label: 'subscription.feature_holidays',
    type: ModuleTypes.holidays,
    sx: {
      top: 0,
      left: 0,
    },
    requiredModules: [ModuleTypes.agreements],
    pricePerUser: 2,
    icon: <HolidayIcon />,
  },
  {
    label: 'agreements.header',
    type: ModuleTypes.agreements,
    sx: {
      top: 0,
      left: wrapperWidth / 2,
      transform: 'translateX(-50%)',
    },
    pricePerUser: 2,
    icon: <UsersIcon />,
  },
  {
    label: 'subscription.feature_projects',
    type: ModuleTypes.timeTracking,
    sx: {
      top: 0,
      right: 0,
    },
    pricePerUser: 1,
    icon: <StopWatchIcon />,
  },
  {
    label: 'subscription.feature_hr',
    type: ModuleTypes.humanResources,
    sx: {
      top: wrapperHeight / 2,
      left: 0,
      transform: 'translateY(-50%)',
    },
    pricePerUser: 0.75,
    price: 75,
    icon: <UserSearchIcon />,
  },
  {
    label: 'subscription.feature_costs',
    type: ModuleTypes.transactions,
    sx: {
      top: wrapperHeight / 2,
      right: 0,
      transform: 'translateY(-50%)',
    },
    pricePerUser: 3,
    price: 50,
    icon: <WalletIcon />,
  },
  {
    label: 'subscription.feature_bookings',
    type: ModuleTypes.bookings,
    sx: {
      bottom: 0,
      left: 0,
    },
    price: 75,
    icon: <OfficeChairIcon />,
  },
];

export default nodules;
